module.exports = __webpack_public_path__ + "img/ic_page_up.9038d465.png";